import { render, staticRenderFns } from "./vipPage.vue?vue&type=template&id=7d0ebbae&"
import script from "./vipPage.vue?vue&type=script&lang=js&"
export * from "./vipPage.vue?vue&type=script&lang=js&"
import style0 from "./vipPage.vue?vue&type=style&index=0&id=7d0ebbae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VPagination,VRow})
